import Fetch from "./index";

export const getCRMIntegration = async (assistantID) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  return Fetch("/assistant/" + assistantID + "/crm")
}

export const createCRMIntegration = async (assistantID, body) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  const data = new FormData();
  for (const key in body) {
    data.set(key, body[key]);
  }

  return Fetch(
    "/assistant/" + assistantID + '/crm/',
    {
      method: 'POST',
      body: data,
    },
  )
}

export const deleteCRMIntegration = async (assistantID, id) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  return Fetch(
    "/assistant/" + assistantID + '/crm/' + id,
    {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
      }
    },
  )
}

export const updateCRMIntegration = async (assistantID, id, body) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  return Fetch(
    "/assistant/" + assistantID + '/crm/' + id,
    {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      }
    },
  )
}
